import { Button } from 'components/lib';
import noop from 'lodash/noop';
import React from 'react';
import ModalStdHeader from './ModalStdHeader';

interface Props {
  id: string;
  headerText: string;
  bodyText: string;
  content: React.ReactNode;
  acceptButtonText: string;
  acceptButtonType: 'primary' | 'error' | 'delete';
  denyButtonText: string;
  acceptCallback: () => void;
  denyCallback: () => void;
  xClickCallback?: () => void;
}

class ConfirmModal extends React.Component<Props> {
  static defaultProps = {
    headerText: 'Are you Sure?',
    bodyText:
      'Unsaved changes will be lost if you cancel. Are you sure you want to continue?',
    acceptButtonText: 'Yes',
    acceptButtonType: 'primary',
    denyButtonText: 'No',
    acceptCallback: noop,
    denyCallback: noop,
  };

  static modalStyles = {
    overlay: {
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
    },
    content: {
      top: 'calc(50vh - 120px)',
      left: '50%',
      bottom: 'initial',
      right: 'initial',
      width: '368px',
      marginLeft: '-184px',
      padding: '0px',
      borderRadius: '8px',
    },
  };

  handleAccept = (): void => {
    this.props.acceptCallback();
  };

  handleDeny = (): void => {
    this.props.denyCallback();
  };

  render(): React.ReactNode {
    const {
      id,
      headerText,
      content,
      acceptButtonText,
      acceptButtonType,
      denyButtonText,
    } = this.props;

    const variantType =
      acceptButtonType === 'error' || acceptButtonType === 'delete'
        ? 'destructive'
        : 'primary';

    return (
      <div id={id} className="modal__content">
        <ModalStdHeader onClose={this.props.xClickCallback} text={headerText} />
        <div className="px5 pt9">
          <div className="mb5 light font-size-5">{content}</div>
        </div>
        <div className="row justify-between bt-solid bt-width-1 bt-light-grey-1 px4 py3">
          <Button
            id={`${id}-deny-btn`}
            onClick={this.handleDeny}
            variant="tertiary"
          >
            {denyButtonText}
          </Button>
          <Button
            id={`${id}-accept-btn`}
            variant={variantType}
            onClick={this.handleAccept}
          >
            {acceptButtonText}
          </Button>
        </div>
      </div>
    );
  }
}

export default ConfirmModal;
